import { Route } from "react-router";
import { Routes } from "react-router-dom";
import {
  ANIMATE_TOOL_PATH,
  BRIEF_TOOL_PATH,
  COPY_AD_TOOL_PATH,
  EDIT_ASSET_TOOL_PATH,
  EDIT_IMAGE_TOOL_PATH,
  EDIT_IMAGE_WITH_PROMPT_TOOL_PATH,
  EDIT_SHAPE_TOOL_PATH,
  EDIT_TEXT_TOOL_PATH,
  EXPAND_TOOL_PATH,
  FILL_TOOL_PATH,
  GENERATE_TOOL_PATH,
  TRANSFER_TOOL_PATH,
  UPSCALE_TOOL_PATH,
  VARIATION_TOOL_PATH,
} from "../../routes.ts";
import { BriefSettings } from "./Workspaces/CreateWorkspace/Tools/BriefView/BriefSettings.tsx";
import { GenerateSettings } from "./Workspaces/CreateWorkspace/Tools/GenerateView/GenerateSettings.tsx";
import { StyleTransferSettings } from "./Workspaces/CreateWorkspace/Tools/StyleTransferView/StyleTransferSettings.tsx";
import { CopyAdSettings } from "./Workspaces/EditWorkspace/Tools/CopyAd/CopyAdSettings.tsx";
import { EditAssetSettings } from "./Workspaces/EditWorkspace/Tools/EditAsset/EditAssetSettings.tsx";
import { EditImageSettings } from "./Workspaces/EditWorkspace/Tools/EditImage/EditImageSettings.tsx";
import { EditShapeSettings } from "./Workspaces/EditWorkspace/Tools/EditShape/EditShapeSettings.tsx";
import { EditTextSettings } from "./Workspaces/EditWorkspace/Tools/EditText/EditTextSettings.tsx";

export const SettingsPanel = () => (
  <Routes>
    <Route path={GENERATE_TOOL_PATH} element={<GenerateSettings />} />
    <Route path={TRANSFER_TOOL_PATH} element={<StyleTransferSettings />} />
    <Route path={BRIEF_TOOL_PATH} element={<BriefSettings />} />
    <Route path={EDIT_ASSET_TOOL_PATH} element={<EditAssetSettings />} />
    <Route path={FILL_TOOL_PATH} element={<EditAssetSettings />} />
    <Route
      path={EDIT_IMAGE_WITH_PROMPT_TOOL_PATH}
      element={<EditAssetSettings />}
    />
    <Route path={VARIATION_TOOL_PATH} element={<EditAssetSettings />} />
    <Route path={UPSCALE_TOOL_PATH} element={<EditAssetSettings />} />
    <Route path={EXPAND_TOOL_PATH} element={<EditAssetSettings />} />
    <Route path={ANIMATE_TOOL_PATH} element={<EditAssetSettings />} />

    <Route path={EDIT_TEXT_TOOL_PATH} element={<EditTextSettings />} />
    <Route path={EDIT_SHAPE_TOOL_PATH} element={<EditShapeSettings />} />
    <Route path={EDIT_IMAGE_TOOL_PATH} element={<EditImageSettings />} />
    <Route path={COPY_AD_TOOL_PATH} element={<CopyAdSettings />} />
  </Routes>
);
